












import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class WithdrawPaypal extends Vue {
    private x: any = 0;
    private y: any = 0;
    private tryContinue() {
        this.x = Math.floor(Math.random() * (window.innerWidth - 1500));
        this.y = Math.floor(Math.random() * (window.innerHeight - 1500));
        console.log(this.x, this.y)
    }
    get style() {
        return `top: ${this.y}px; left: ${this.x}px`
    }
}
